export default __webpack_public_path__ + "static/media/4836346A.7e024016.png";